import React from 'react';

import { WhyTrustUsSection } from '../../../components/PDP/WhyTrustUsSection';
import { FluidObject } from 'gatsby-image';

type ContentSection = {
  headline: string;
  subHeadline: string;
  image: {
    fluid: FluidObject;
  };
  cta: { text: string; url: string };
};

export interface WhyTrustUsContainerProps {
  content: {
    listOfContentSections: ContentSection[];
  };
}

export const WhyTrustUsContainer: React.FC<WhyTrustUsContainerProps> = ({
  content,
}) => {
  if (!content) {
    return null;
  }
  const { listOfContentSections } = content;

  if (!listOfContentSections) return null;

  const listOfContent = listOfContentSections.map((content: any) => ({
    heading: content.headline,
    description: content.subHeadline,
    image: content.image.fluid,
    imageAlt: content.image?.description,
    cta: content.cta,
  }));

  return <WhyTrustUsSection listOfContent={listOfContent} />;
};

export default WhyTrustUsContainer;
